import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SafeUrl } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'pcg-help-videos',
    templateUrl: './help-videos.component.html',
    styleUrls: ['./help-videos.component.scss'],
    standalone: false
})
export class HelpVideosComponent implements OnInit {

	id: Number;
	name: string;
	description: string;
	moduleName: string;
	url: SafeUrl;

	constructor(
        private activeRoute: ActivatedRoute
        , private httpClient: HttpClient
    ) { }

	ngOnInit() {
		// Get the video id
		this.id = parseInt(this.activeRoute.snapshot.paramMap.get('id')!, 10);
		this.getVideoContent();
	}

	/** Get Video data from the server */
	getVideoContent() {
		this.httpClient.get(`api/HelpFiles/HelpFiles/GetDetails/${this.id}`)
            .subscribe((model: any) => {
                const videoId = Number(model.videoId);
                this.url = `https://player.vimeo.com/video/${videoId}`;
                this.name = model.name;
                this.description = model.description;
                this.moduleName = model.moduleName;
            }
        );
	}
}
